import React from 'react';

const ClientConfigPA = () => {
  return (
    <section>
        <div style={{marginLeft: '30px'}}>
                <p>Instructions to configure the Client - Postman to consume the Patient Access FHIR®API</p>
                <table class="table table-bordered table-hover">
                    <tbody>
                        <tr>
                            <td>Base_URL</td>
                            <td>https://accares.acgov.org/api</td>
                        </tr>
                    </tbody>
                </table>
                <h4> Steps: </h4>
                <ol style={{padding:'0px 30px'}}>
                    <li>Start your API client (i.e., Postman v5.3.1+)</li>
                    <li>Enter the example URL below and select GET as the HTTP verb<br /><b>Ex: </b>{`https://accares.acgov.org/api/Condition/_search?Patient={Identifier}`}</li>

                    <li>Click the Authorization Tab and select "OAuth 2.0" from the Type dropdown menu</li>
                    <li>Enter the configuration details from the <a href="#postmanID" class="w3-text-blue">table below </a></li>
                    <li>Click the "Clear cookies" button</li>
                    <li>Click the "Get New Access Token" button</li>
                    <li>Enter the registered username and password</li>
                    <li>Review the consent screen then click the "Yes, Allow" button</li>
                    <li>Once successful, the Manage Access Tokens pop up will display along with the token details</li>
                    <li>Scroll down until you see the "patient" claim. This is the patient identifier. Copy this value.</li>
                    <li>Click the "Use Token" button to use the Access Token</li>
                    <li>{`Replace "{Identifier}" in the GET request URL with the patient identifier value you copied earlier.<br /><b>Ex: </b>https://accares.acgov.org/api/Condition/_search?Patient=12345678`}</li>
                    <li>Click the "Send" button to retrieve the requested resources</li>
                </ol>
                <p id="postmanID">For any previous versions of Postman client, please add the Access Token manually to the URL Header</p>
                <ul style={{padding: '0px 30px'}}>
                    <li><b>Key: </b>Authorization</li>
                    <li><b>Value: </b>Bearer Access Token (E.g., bearer D5jkd3adf23aERsdgy312)</li>
                </ul>
                <br />
                <h4 align="center">Postman Configuration for Authorization code flow</h4>

                <table id="postmanTableID" class="table table-bordered table-hover">
                    <thead>
                        <tr>
                            <th>NAME</th>
                            <th style={{marginLeft:'20px'}}>DETAILS</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td style={{width:'200px'}}>Token Name</td>
                            <td>FHIR®Token</td>
                        </tr>
                        <tr>
                            <td>Grant Type</td>
                            <td>Authorization Code</td>
                        </tr>

                        <tr>
                            <td>Callback URL</td>

                            <td>https://www.getpostman.com/oauth2/callback</td>
                        </tr>
                        <tr>
                            <td>Auth URL</td>
                            <td>N/A</td>
                        </tr>
                        <tr>
                            <td>Access Token URL</td>
                            <td>https://accares.acgov.org/identity/connect/token</td>
                        </tr>
                        <tr>
                            <td>Client Id</td>
                            <td>Sample Client ID</td>
                        </tr>
                        <tr>
                            <td>Client Secret</td>
                            <td>Sample Secret</td>
                        </tr>
                        <tr>
                            <td>Scope</td>
                            <td>openid patient/*.read</td>
                        </tr>
                        <tr>
                            <td>State</td>
                            <td>Any GUID ID (Recommended)</td>
                        </tr>
                        <tr>
                            <td>Client Authorization</td>
                            <td>Send as Basic Auth Header</td>
                        </tr>
                    </tbody>
                </table>

                <div id="AuthorizationCodeflowwithPKCE" class="col-md-12" style={{margin: '0 auto'}}>
                    <h4>Authorization Code flow with PKCE</h4>
                    <div style={{marginLeft: '30px'}}>
                        <p>Proof Key for Code Exchange (PKCE) is an industry standard that can help mitigate CSRF and other known security threats. </p>
                        <p>The  Authorization Code flow with PKCE is similar to the regular Authorization Code flow, but with an additional step at the start and an additional verification at the end. </p>
                    </div>
                </div>
                <h4 align="center">Postman Configuration for Authorization code flow with PKCE</h4>

                <table id="postmanTableID" class="table table-bordered table-hover">
                    <thead>
                        <tr>
                            <th>NAME</th>
                            <th style={{marginLeft:'20px'}}>DETAILS</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td style={{width:'200px'}}>Token Name</td>
                            <td>FHIR_Token</td>
                        </tr>
                        <tr>
                            <td>Grant Type</td>
                            <td>Authorization Code (With PKCE)</td>
                        </tr>

                        <tr>
                            <td>Callback URL</td>

                            <td>https://www.getpostman.com/oauth2/callback</td>
                        </tr>
                        <tr>
                            <td>Auth URL</td>
                            <td>N/A</td>
                        </tr>
                        <tr>
                            <td>Access Token URL</td>
                            <td>https://accares.acgov.org/identity/connect/token</td>
                        </tr>
                        <tr>
                            <td>Client Id</td>
                            <td>Sample Client ID</td>
                        </tr>
                        <tr>
                            <td>Client Secret</td>
                            <td>Sample Secret</td>
                        </tr>
                        <tr>
                            <td>Code Challenge Method</td>
                            <td>Sample Secret</td>
                        </tr>
                        <tr>
                            <td>Code Verifier</td>
                            <td>Postman client will generate this value automatically if left blank</td>
                        </tr>
                        <tr>
                            <td>Scope</td>
                            <td>openid patient/*.read</td>
                        </tr>
                        <tr>
                            <td>State</td>
                            <td>Any GUID ID (Recommended)</td>
                        </tr>
                        <tr>
                            <td>Client Authorization</td>
                            <td>Send as Basic Auth Header</td>
                        </tr>
                    </tbody>
                </table>

            </div>
            <div>
            <h3>API Documentation</h3>
            <p>
                Details regarding the API, including supported endpoints, search parameters, required parameters, return values, error types, and more are 
                available <a href="https://accares.acgov.org/api/swagger/index.html?urls.primaryName=Patient%20Access%20API%20v1">HERE</a>.
            </p>
        </div>
      </section>
  );
};

export default ClientConfigPA;